import { Api } from '@lib/api'

export function useLoggedIn() {
  return !!Api.getAuthToken()
}
